import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import MenuItem from '~/components/core/Atomic/MenuItem';
import { useLobConfiguration } from '~/components/hooks/useLobConfiguration';

import { getLobDescription } from '../../../Utils/lobUtils';
import useOrganization from '../../OrganizationContext';
import TextFieldFormik from '../../TextFieldFormik';

import useLobOptions from './hooks/useLobOptions';

import { useStyles } from '../../../assets/styles';

export const LobSelectFormik = ({
  fieldId,
  subOrganizationIds = [],
  disabled = false,
  label = 'Line of Business',
  onChange = undefined,
}) => {
  const { classes } = useStyles();
  const { subOrganizationEnabled } = useOrganization();
  const { lobOptions, isLoading } = useLobOptions({ subOrganizationIds });
  const { lobConfigurationsDict } = useLobConfiguration();

  const isDisabled = disabled || isLoading || (subOrganizationEnabled && _.isEmpty(subOrganizationIds));

  // When onChange is supplied it replaces Formik's handleChange, so the caller owns setting the field
  // value (mirrors SubOrganizationSelectFormik's onChange contract). Note TextFieldFormik may invoke it
  // with a synthetic `{ target: { name, value } }` shim (not a real React event) — read only target.value.
  return (
    <TextFieldFormik
      id={fieldId}
      label={label}
      className={classes.textField}
      disabled={isDisabled}
      select
      fullWidth
      onChange={onChange}
    >
      {lobOptions.map((lob) => (
        <MenuItem key={lob} value={lob}>
          {getLobDescription(lob, lobConfigurationsDict)}
        </MenuItem>
      ))}
    </TextFieldFormik>
  );
};

LobSelectFormik.propTypes = {
  subOrganizationIds: PropTypes.array.isRequired,
  fieldId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
};
